import React, { SVGProps } from 'react'
import {
  LayoutDashboard,
  Home,
  Briefcase,
  Users as UsersIcon,
  User as ContactsIcon,
  HardHat,
  Hammer,
  Ticket,
  Truck,
  ClipboardList,
  Clock,
  ListOrdered,
  ChartLine,
  DollarSign,
  Cog,
  CreditCard,
  MapPin,
  FileText,
} from 'lucide-react'

/**
 * Navigation item definition
 */
export type NavItem = {
  label: string
  /**
   * Icon element (SVG) accepting standard SVG props like className
   */
  icon: React.ReactElement<SVGProps<SVGSVGElement>>
  href?: string        // when undefined or comingSoon, item is disabled
  comingSoon?: boolean // visually indicate future feature
  children?: NavItem[] // submenu
}

/**
 * Sidebar navigation configuration
 */
const navConfig: NavItem[] = [
  {
    label: 'Home',
    icon: <Home />,  
    children: [
      { label: 'Dashboard', icon: <LayoutDashboard />, href: '/myteconstruction/dashboard' },
      { label: 'Company Insights', icon: <ChartLine />, comingSoon: true },
    ],
  },
  {
    label: 'Projects',
    icon: <Briefcase />,  
    children: [
      { label: 'Active Projects', icon: <Briefcase />, href: '/myteconstruction/dashboard/projects' },
      { label: 'Project Templates', icon: <FileText />, comingSoon: true },
    ],
  },
  {
    label: 'People',
    icon: <UsersIcon />,  
    children: [
      { label: 'Contacts', icon: <ContactsIcon />, href: '/myteconstruction/dashboard/contacts' },
      { label: 'Foremen', icon: <HardHat />, href: '/myteconstruction/dashboard/foremen' },
      { label: 'Project Managers', icon: <Briefcase />, href: '/myteconstruction/dashboard/project-managers' },
      { label: 'Ironworkers', icon: <Hammer />, href: '/myteconstruction/dashboard/ironworkers' },
    ],
  },
  {
    label: 'Resources',
    icon: <ClipboardList />,  
    children: [
      { label: 'Seats / Licences', icon: <Ticket />, href: '/myteconstruction/dashboard/seats' },
      { label: 'Equipment Requests', icon: <Truck />, comingSoon: true },
    ],
  },
  {
    label: 'Field Ops',
    icon: <MapPin />,  
    children: [
      { label: 'Timesheets', icon: <Clock />, comingSoon: true },
      { label: 'Punch-lists', icon: <ListOrdered />, comingSoon: true },
    ],
  },
  {
    label: 'Sales & Estimating',
    icon: <ChartLine />,  
    children: [
      { label: 'Bids', icon: <DollarSign />, comingSoon: true },
      { label: 'CRM Leads', icon: <UsersIcon />, comingSoon: true },
    ],
  },
  {
    label: 'Administration',
    icon: <Cog />,  
    children: [
      { label: 'Organization Settings', icon: <Cog />, comingSoon: true },
      { label: 'Cost Codes', icon: <DollarSign />, href: '/myteconstruction/dashboard/cost-codes' },
      { label: 'Billing & Seats', icon: <CreditCard />, comingSoon: true },
    ],
  },
]

export default navConfig